// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"user-talk"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M16 7.5C16 9.98528 13.9853 12 11.5 12C9.01472 12 7 9.98528 7 7.5C7 5.01472 9.01472 3 11.5 3C13.9853 3 16 5.01472 16 7.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 15H8C5.23858 15 3 17.2386 3 20V21H12.0508M16 7.5C16 9.98528 13.9853 12 11.5 12C9.01472 12 7 9.98528 7 7.5C7 5.01472 9.01472 3 11.5 3C13.9853 3 16 5.01472 16 7.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M15.9941 19.5059C16.3223 19.0719 16.5 18.5428 16.5002 17.9987C16.5004 17.4546 16.3231 16.9254 15.9952 16.4912M18.7852 21.618C19.5728 20.5765 19.9992 19.3066 19.9997 18.0008C20.0001 16.6951 19.5746 15.4248 18.7877 14.3828","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const UserTalkIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'user-talk',
    ref,
    icon: element,
  },
));

UserTalkIcon.displayName = 'UserTalkIcon';

export default UserTalkIcon;
